import { DesignSystem } from "@clickbank-ui/seller-design-system";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme(DesignSystem.designSystemV5, {
	components: {
		MuiTextField: {
			defaultProps: {
				className: "inputLg",
			},
		},
	},
});
